import { UserCheck, ArrowLeftCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

/**
 * Visar en sticky banner när admin är inloggad som ett annat barn-konto.
 * Klick på "Tillbaka till adminkontot" återställer original-tokenen.
 */
export function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const adminToken = typeof window !== "undefined"
    ? localStorage.getItem("grindstugatan_admin_token")
    : null;
  if (!adminToken || !user) return null;

  const restoreAdmin = () => {
    localStorage.setItem("grindstugatan_token", adminToken);
    localStorage.removeItem("grindstugatan_admin_token");
    toast.success("Tillbaka som admin");
    if (refresh) refresh();
    setTimeout(() => { window.location.href = "/installningar"; }, 200);
  };

  return (
    <div
      className="sticky top-0 z-40 bg-[#FEF3C7] border-b border-[#F59E0B] px-3 py-2 text-xs flex items-center justify-between gap-2"
      data-testid="impersonation-banner"
    >
      <span className="flex items-center gap-1.5 text-[#92400E]">
        <UserCheck size={14} />
        <span className="font-medium">Inloggad som {user.name?.split(" ")[0] || user.name}</span>
      </span>
      <button
        onClick={restoreAdmin}
        className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-white text-[#92400E] font-medium border border-[#F59E0B] hover:bg-[#FFFBEB]"
        data-testid="restore-admin-button"
      >
        <ArrowLeftCircle size={12} /> Tillbaka till adminkontot
      </button>
    </div>
  );
}
